import { type CSSObject } from '@emotion/react'
import { radioClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

export const RADIO_PADDING_VALUE = 10
const NEGATIVE_RADIO_MARGIN_VALUE = 2

export const getHoverStyle = (theme: Theme): CSSObject => ({
  backgroundColor: 'initial',
  color: theme.palette.text.secondary,
})

export const getCheckedHoverStyle = (theme: Theme): CSSObject => ({
  backgroundColor: 'initial',
  color: theme.palette.primary.dark,
})

export const overridesRadio = (theme: Theme): ComponentsOverrides['MuiRadio'] => ({
  root: {
    // Zone de tap = taille radio (24) + padding (10 * 2) = 44 -> conforme recommandation accessibilité
    // Espacement visuel = padding (10) - margin (2) = 8 -> conforme DS
    margin: `-${rem(NEGATIVE_RADIO_MARGIN_VALUE)}`,
    padding: rem(RADIO_PADDING_VALUE),
    '&:hover': getHoverStyle(theme),
    color: theme.customPalette.onElements.outline,
  },
  colorPrimary: {
    [`&.${radioClasses.checked}`]: {
      '&:hover': getCheckedHoverStyle(theme),
      color: theme.palette.primary.main,
    },
  },
})
